import React, { useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import momentPropTypes from 'react-moment-proptypes'

import DateFieldRange from "../../common/forms/DateFieldRange"
import { isMobile } from 'react-device-detect'
import {
  calcNightsMoment
} from '../../helpers/searchHelpers'

import {
  earliestStartDate,
  isDateBlockedForSelection
} from '../../helpers/general'

const DestinationsDateFields = ({
  arrival,
  setArrival,
  minNights,
  setNights,
  setPlaying,
  departure,
  setDeparture
}) => {
  const [dateFocused, setDateFocused] = useState(null)

  const _dateChangeHandler = ({ startDate, endDate }) => {
    if(startDate) {
      if (startDate < moment().hours(0)) return false
      setArrival(startDate)

      let minDeparture = moment(startDate).add(minNights, 'days')
      setDeparture(minDeparture)
      setDateFocused("endDate")
    }

    if(endDate) {
      setDeparture(endDate)
      setNights(calcNightsMoment(startDate, endDate))
      setDateFocused(null)
    }
  }

  const _onDateFocusChange = focused => {
    setDateFocused(focused)
    if(focused) setPlaying(false)
  }

  const _getNumberOfMonths = () => isMobile ? 1 : 2

  return (
    <DateFieldRange
      startDate                 = {arrival}
      endDate                   = {departure}
      focusedInput              = {dateFocused}
      onDatesChange             = {_dateChangeHandler}
      onFocusChange             = {_onDateFocusChange}
      minimumNights             = {minNights}
      isDayBlocked              = {isDateBlockedForSelection}
      numberOfMonths            = {_getNumberOfMonths()}
      keepOpenOnDateSelect      = {false}
      initialVisibleMonth       = {() => earliestStartDate()}
      showDefaultInputIcon      = {false}
      withPortal                = {true}
      startDatePlaceholderText  = "Arrival"
      endDatePlaceholderText    = "Departure"
      />
  )
}

DestinationsDateFields.propTypes = {
  arrival: momentPropTypes.momentObj,
  setArrival: PropTypes.func.isRequired,
  minNights: PropTypes.number.isRequired,
  setNights: PropTypes.func.isRequired,
  setPlaying: PropTypes.func.isRequired,
  departure: momentPropTypes.momentObj,
  setDeparture: PropTypes.func.isRequired
}

export default DestinationsDateFields
